{
  "customer-form-dialog": {
    "field": {
      "last_checkin": "Poslední check-in",
      "number_of_visit": "Počet návštěv",
      "registered_since": "Registrován od",
      "type": "Typ"
    },
    "button": {
      "cancel": "Zrušit",
      "submit": "Odeslat"
    },
    "text": {
      "create_customer": "Vytvoření nového profilu zákazníka",
      "create_customer_success": "Úspěšně vytvořeno",
      "edit_customer": "Upravit profil zákazníka",
      "edit_customer_success": "Úspěšně aktualizováno",
      "off": "OFF",
      "on": "ON"
    }
  }
}
